import { projectsProjectDetailHostCapability, projectsProjectDetailHostSlots, } from '@crest/module-projects/contracts/detail-host';
import { defineProjectsProjectDetailLauncher } from '@crest/module-projects/contracts/detail-launcher';
import { financeModuleManifest } from '../finance.module.js';
import { financeSettingRegistrations } from '../settings/finance-setting-definitions.js';
export const financeWebModuleContribution = {
    moduleId: 'finance',
    manifest: financeModuleManifest,
    settingRegistrations: financeSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [{
            id: 'finance.web.projects.billing-summary',
            moduleId: 'finance',
            slot: projectsProjectDetailHostSlots.sidebar,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'finance.invoices.read',
            settingCondition: {
                key: 'finance.invoices.configuration',
                property: 'projectPanelEnabled',
                equals: true,
            },
            priority: 40,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            launcher: defineProjectsProjectDetailLauncher({
                fallbackLabel: 'Finance',
                fallbackDescription: 'Review billing and financial activity for this Project.',
                defaultSize: 'wide',
                supportedSizes: ['standard', 'wide', 'large'],
            }),
            load: () => import('./finance-project-billing-panel.js'),
        }],
    routes: [{
            id: 'finance.web.invoices',
            moduleId: 'finance',
            path: '/finance/invoices',
            requiredPermission: 'finance.invoices.read',
            navigation: {
                id: 'finance.navigation.invoices',
                fallbackLabel: 'Invoices',
                labelConfigurationKey: 'finance.copy.invoices',
                labelValueProperty: 'navigationLabel',
                priority: 40,
            },
            load: () => import('./finance-invoices.page.js'),
        }, {
            id: 'finance.web.expenses',
            moduleId: 'finance',
            path: '/finance/expenses',
            requiredPermission: 'finance.expenses.read',
            navigation: {
                id: 'finance.navigation.expenses',
                fallbackLabel: 'Expenses',
                labelConfigurationKey: 'finance.copy.expenses',
                labelValueProperty: 'navigationLabel',
                priority: 45,
            },
            load: () => import('./finance-expenses.page.js'),
        }, {
            id: 'finance.web.overhead',
            moduleId: 'finance',
            path: '/finance/overhead',
            requiredPermission: 'finance.overhead.read',
            navigation: {
                id: 'finance.navigation.overhead',
                fallbackLabel: 'Overhead',
                labelConfigurationKey: 'finance.copy.overhead',
                labelValueProperty: 'navigationLabel',
                priority: 50,
            },
            load: () => import('./finance-overhead.page.js'),
        }, {
            id: 'finance.web.reconciliation',
            moduleId: 'finance',
            path: '/finance/reconciliation',
            requiredPermission: 'finance.reconciliation.read',
            navigation: {
                id: 'finance.navigation.reconciliation',
                fallbackLabel: 'Reconciliation',
                labelConfigurationKey: 'finance.copy.reconciliation',
                labelValueProperty: 'navigationLabel',
                priority: 55,
            },
            load: () => import('./finance-reconciliation.page.js'),
        }, {
            id: 'finance.web.payments',
            moduleId: 'finance',
            path: '/finance/payments',
            requiredPermission: 'finance.payments.read',
            navigation: {
                id: 'finance.navigation.payments',
                fallbackLabel: 'Payments',
                labelConfigurationKey: 'finance.copy.payments',
                labelValueProperty: 'navigationLabel',
                priority: 60,
            },
            load: () => import('./finance-payments.page.js'),
        }, {
            id: 'finance.web.project-profitability',
            moduleId: 'finance',
            path: '/finance/profitability',
            requiredPermission: 'finance.profitability.read',
            navigation: {
                id: 'finance.navigation.project-profitability',
                fallbackLabel: 'Profitability',
                labelConfigurationKey: 'finance.copy.profitability',
                labelValueProperty: 'navigationLabel',
                priority: 65,
            },
            load: () => import('./finance-project-profitability.page.js'),
        }, {
            id: 'finance.web.referral-commissions',
            moduleId: 'finance',
            path: '/finance/commissions',
            requiredPermission: 'finance.commissions.read',
            navigation: {
                id: 'finance.navigation.referral-commissions',
                fallbackLabel: 'Commissions',
                labelConfigurationKey: 'finance.copy.commissions',
                labelValueProperty: 'navigationLabel',
                priority: 70,
            },
            load: () => import('./finance-referral-commissions.page.js'),
        }],
};
export default financeWebModuleContribution;
//# sourceMappingURL=finance-web.module-contribution.js.map